import { ApiFilterKeys } from '../api/index.js';

export enum FilterType {
  SELECT_MANY = 'SELECT_MANY',
  SELECT_ONE = 'SELECT_ONE',
  NUMBER_RANGE = 'NUMBER_RANGE',
}

export enum FilterKey {
  ACTIVITY_STATUS = 'filter_activityStatus',
  COMPLETE = 'filter_complete',
  INCOMPLETE = 'filter_incomplete',
  INTERVIEW = 'filter_interview',
  RECORDED_INTERVIEW = 'filter_recordedInterview',
  FUNDS_MATURITY = 'filter_fundsMaturity',
  CONDITIONAL_STATUS = 'filter_conditionalStatus',
  COURSE_CONDITIONAL_STATUS = 'filter_courseConditionalStatus',
  COURSE = 'filter_course',
  FACULTY = 'filter_faculty',
  UNIVERSITY = 'filter_university',
  IMMIGRATION_PROVIDERS = 'filter_immigrationProviders',
  PROGRAMMABLE_TAGS = 'filter_programmableTags',
  SERVICES = 'filter_services',
  TAGS = 'filter_tags',
  VISA_STATUS = 'filter_visaStatus',
  AGENT_NAME = 'filter_agentName',
  APPLICATION_COUNTRY = 'filter_applicationCountry',
  CONFIDENCE = 'filter_confidence',
  COUNTRY_OF_RESIDENCE = 'filter_countryOfResidence',
  EVIDENCE_REQUIREMENTS = 'filter_evidenceRequirements',
  MARKET = 'filter_market',
  NATIONALITY = 'filter_nationality',
  RISK_REGION = 'filter_riskRegion',
  IDLE_DAYS = 'filter_idle_days',
  MINIMUM_DAYS_IDLE = 'filter_minimum_days_idle',
  MAXIMUM_DAYS_IDLE = 'filter_maximum_days_idle',
  DEPENDANTS = 'filter_dependants',
  STUDENT_NUMBER = 'filter_student_number',
  GIVEN_NAME = 'filter_given_name',
  FAMILY_NAME = 'filter_surname',
  FEE_STATUS = 'filter_feeStatus',
  OFFER_STATUS = 'filter_offerStatus',
  SHARE_CODE = 'filter_shareCode',
}

export const FilterKeyValues = Object.values(FilterKey);

// Maps the QSP filter keys to their IFilterParam interface attribute.
export const FilterKeyMap = Object.freeze({
  [FilterKey.ACTIVITY_STATUS]: ApiFilterKeys.ACTIVITY_STATUS,
  [FilterKey.COMPLETE]: ApiFilterKeys.COMPLETE,
  [FilterKey.INCOMPLETE]: ApiFilterKeys.INCOMPLETE,
  [FilterKey.INTERVIEW]: ApiFilterKeys.INTERVIEW,
  [FilterKey.RECORDED_INTERVIEW]: ApiFilterKeys.RECORDED_INTERVIEW,
  [FilterKey.FUNDS_MATURITY]: ApiFilterKeys.FUNDS_MATURITY,
  [FilterKey.CONDITIONAL_STATUS]: ApiFilterKeys.CONDITIONAL_STATUS,
  [FilterKey.COURSE_CONDITIONAL_STATUS]: ApiFilterKeys.COURSE_CONDITIONAL_STATUS,
  [FilterKey.COURSE]: ApiFilterKeys.COURSE,
  [FilterKey.FACULTY]: ApiFilterKeys.FACULTY,
  [FilterKey.UNIVERSITY]: ApiFilterKeys.UNI,
  [FilterKey.IMMIGRATION_PROVIDERS]: ApiFilterKeys.IMMIGRATION_PROVIDERS,
  [FilterKey.PROGRAMMABLE_TAGS]: ApiFilterKeys.PROGRAMMABLE_TAG,
  [FilterKey.SERVICES]: ApiFilterKeys.SERVICES,
  [FilterKey.TAGS]: ApiFilterKeys.TAG,
  [FilterKey.VISA_STATUS]: ApiFilterKeys.VISA_STATUS,
  [FilterKey.AGENT_NAME]: ApiFilterKeys.AGENT,
  [FilterKey.APPLICATION_COUNTRY]: ApiFilterKeys.APPLICATION_COUNTRY,
  [FilterKey.CONFIDENCE]: ApiFilterKeys.CONFIDENCE,
  [FilterKey.COUNTRY_OF_RESIDENCE]: ApiFilterKeys.COUNTRY,
  [FilterKey.EVIDENCE_REQUIREMENTS]: ApiFilterKeys.EVIDENCE_REQUIREMENTS,
  [FilterKey.MARKET]: ApiFilterKeys.MARKET,
  [FilterKey.NATIONALITY]: ApiFilterKeys.NATIONALITY,
  [FilterKey.RISK_REGION]: ApiFilterKeys.REGION,
  [FilterKey.IDLE_DAYS]: ApiFilterKeys.IDLE,
  [FilterKey.MINIMUM_DAYS_IDLE]: ApiFilterKeys.IDLE_FROM,
  [FilterKey.MAXIMUM_DAYS_IDLE]: ApiFilterKeys.IDLE_TO,
  [FilterKey.DEPENDANTS]: null,
  [FilterKey.STUDENT_NUMBER]: ApiFilterKeys.STUDENT_NO,
  [FilterKey.GIVEN_NAME]: ApiFilterKeys.GIVEN_NAME,
  [FilterKey.FAMILY_NAME]: ApiFilterKeys.SURNAME,
  [FilterKey.FEE_STATUS]: ApiFilterKeys.FEE_STATUS,
  [FilterKey.OFFER_STATUS]: ApiFilterKeys.OFFER_STATUS,
  [FilterKey.SHARE_CODE]: ApiFilterKeys.SHARE_CODE,
});
